import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { fetchJackpotsV2Multiple } from '@/model/jackpotsV2';
import { JackpotFeedsDataType, JackpotProvidersUnion } from '@/types/jackpotTypes';

export type JackpotFeedsData = {
  status: number;
  data: Array<{ provider: JackpotProvidersUnion; data: JackpotFeedsDataType }>;
}

export const fetchJackpotFeeds = (
  context: LogicContext
) => async (): Promise<JackpotFeedsData> => {
  const currency = context.user?.currency || config.default_currency;
  const { jackpots } = context;
  const emptyResponse = { status: 200, data: [] };

  if (!jackpots) {
    return emptyResponse;
  }
  
  const feedsData = await Promise.all(
    Object.entries(jackpots).map(async ([provider, codes]) => {
      const data = await fetchJackpotsV2Multiple({
        currency,
        gamesJackpotCodes: Object.keys(codes),
        provider: provider as JackpotProvidersUnion,
      });
      return { provider: provider as JackpotProvidersUnion, data };
    })
  );

  if (feedsData) {
    return {
      status: 200,
      data: feedsData,
    };
  }

  console.error('There was a problem while fetching Jackpot feeds.');
  
  return {
    status: 400,
    data: [],
  };
};
